const claseServCli = (codigoTarifa, servicios) => {
  let claseServSig = "NoDefinida", claseServSig1 = ""
  if(codigoTarifa){
    claseServSig1 = servicios[0].subclaseserv.claseserv.descrClaseServ
    claseServSig = servicios[0].subclaseserv.claseserv.descrClaseServ
    servicios.forEach((elemento, _id) => {
      if(claseServSig1!==elemento.subclaseserv.claseserv.descrClaseServ){
        claseServSig = "NoDefinida"
      }
    })
  }
  return(claseServSig)
}

export default claseServCli
